import _uniqBy from 'lodash.uniqby';

export default function mergeAddon(
addonType,
addonValue,
existingAddons)
{
  const existingAddon = existingAddons[addonType] || {};

  if (addonValue === undefined || addonValue === null) {
    const { [addonType]: removedAddon, ...rest } = existingAddons;

    return rest;
  }

  if (Array.isArray(addonValue)) {
    const newAddonValue = Array.isArray(existingAddon) ?
    _uniqBy([...addonValue, ...existingAddon], 'value') :
    [...addonValue];

    return {
      ...existingAddons,
      [addonType]: newAddonValue
    };
  }

  return {
    ...existingAddons,
    [addonType]: { ...existingAddon, ...addonValue }
  };
}